export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
export const STORAGE_ENCRYPTION_LABEL = "encrypt-time";
